import { useQuery } from '@tanstack/react-query'
import { fetchOrgInfo } from '@api/common/api.js'

export const useOrgInfoQuery = (body = {}) => {
  return useQuery({
    queryKey: ['org-info', body],
    queryFn: () => fetchOrgInfo(body),
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: false,
    throwOnError: true
  })
}
